// https://github.com/backstage/backstage/blob/master/plugins/home/README.md
import { HomePageCompanyLogo } from '@backstage/plugin-home';
import { Content, Page } from '@backstage/core-components';
import { HomePageSearchBar } from '@backstage/plugin-search';
import { SearchContextProvider } from '@backstage/plugin-search-react';
import { Grid, makeStyles } from '@material-ui/core';
import React, { FunctionComponent } from 'react';
import LogoFull from '../Root/LogoFull';

const styles = makeStyles(() => ({
  searchBar: {
    display: 'flex',
    maxWidth: '60vw',
    padding: '8px 0',
    borderRadius: '50px',
    margin: 'auto',
  },
}));

const logoStyles = makeStyles(theme => ({
  container: {
    margin: theme.spacing(5, 0),
  },
}));

interface OwnProps {}

type Props = OwnProps;

export const HomePage: FunctionComponent<Props> = () => {
  const classes = styles();
  const { container } = logoStyles();

  return (
    <SearchContextProvider>
      <Page themeId="home">
        <Content>
          <Grid container justifyContent="center" spacing={6}>
            <HomePageCompanyLogo className={container} logo={<LogoFull />} />
            <Grid container item>
              <HomePageSearchBar classes={{ root: classes.searchBar }} placeholder="Search" />
            </Grid>
          </Grid>
        </Content>
      </Page>
    </SearchContextProvider>
  );
};
